/**
 * PDP レイアウト補助（テーマ側・head 読み込み・全商品共通で即時反映）
 *
 * 1) 宣言的 Shadow DOM（<template shadowrootmode>）の機能検出。
 *    非対応（古い Safari 等）なら <html> に .ktob-no-dsd を即付与し、
 *    product.css 側の「メタ列を必ず縦積みにする保険」を有効化する。
 *    さらに DOMContentLoaded で <template shadowrootmode> を実体の Shadow Root
 *    に変換（imperative attachShadow は Safari 10+）してコンポーネントの
 *    内部スタイルも復元する。
 * 2) 空白のみの conditional liquid ラッパーを折りたたむ（:empty 補完）。
 * 3) スマホの標準表がはみ出すとき、横スクロールできることを右端フェードで示唆。
 *
 * 並び順は product.css の flex 縦積み（ソース順）で確定する。DOM の並べ替えはしない。
 */
(function () {
  /* ---- 1) 宣言的 Shadow DOM 検出 + ポリフィル ---- */
  (function () {
    var supportsDSD = false;
    try {
      supportsDSD =
        typeof HTMLTemplateElement !== "undefined" &&
        Object.prototype.hasOwnProperty.call(
          HTMLTemplateElement.prototype,
          "shadowRootMode"
        );
    } catch (_e) {
      supportsDSD = false;
    }
    if (supportsDSD) return; // 新しいブラウザは何もしない

    // CSS 保険を効かせるためのフラグ（head 段階で <html> に付与）
    try {
      document.documentElement.className += " ktob-no-dsd";
    } catch (_e) {}

    if (window.__ktobDsdPolyfillInit) return;
    window.__ktobDsdPolyfillInit = true;

    function attachShadowRoots(root) {
      var tpls = root.querySelectorAll(
        "template[shadowrootmode], template[shadowroot]"
      );
      for (var i = 0; i < tpls.length; i++) {
        var tpl = tpls[i];
        var host = tpl.parentNode;
        if (!host || typeof host.attachShadow !== "function") continue;
        if (host.shadowRoot) {
          tpl.remove();
          continue;
        }
        var mode =
          tpl.getAttribute("shadowrootmode") ||
          tpl.getAttribute("shadowroot") ||
          "open";
        try {
          var sr = host.attachShadow({ mode: mode });
          sr.appendChild(tpl.content.cloneNode(true));
          tpl.remove();
          attachShadowRoots(sr);
        } catch (_e) {}
      }
    }
    function runPolyfill() {
      attachShadowRoots(document);
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", runPolyfill);
    } else {
      runPolyfill();
    }
    window.addEventListener("load", runPolyfill);
    document.addEventListener("shopify:section:load", runPolyfill);
  })();

  /* ---- 3) スマホ標準表の横スクロール示唆 ---- */
  (function () {
    if (window.__ktobRteTableScrollHint) return;
    window.__ktobRteTableScrollHint = true;

    var MQ = "(max-width: 768px)";
    var ATTR_RIGHT = "data-ktob-scroll-right";
    var ATTR_LEFT = "data-ktob-scroll-left";

    function isPlainProductTable(table) {
      if (!table || table.tagName !== "TABLE") return false;
      if (table.closest(".ktob-opt-table")) return false;
      if (table.closest(".so-box")) return false;
      if (table.closest("[class^='tbl-'], [class*=' tbl-']")) return false;
      if (table.className && String(table.className).indexOf("tbl-") === 0) {
        return false;
      }
      return true;
    }

    function updateHints(wrap, scroller) {
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (max > 6) {
        if (scroller.scrollLeft < max - 6) wrap.setAttribute(ATTR_RIGHT, "");
        else wrap.removeAttribute(ATTR_RIGHT);
        if (scroller.scrollLeft > 6) wrap.setAttribute(ATTR_LEFT, "");
        else wrap.removeAttribute(ATTR_LEFT);
        wrap.setAttribute("data-ktob-scrollable", "");
      } else {
        wrap.removeAttribute(ATTR_RIGHT);
        wrap.removeAttribute(ATTR_LEFT);
        wrap.removeAttribute("data-ktob-scrollable");
      }
    }

    function enhanceTable(table) {
      if (!isPlainProductTable(table)) return;
      if (table.closest(".ktob-rte-table-scroll")) return;

      var wrap = document.createElement("div");
      wrap.className = "ktob-rte-table-scroll";
      var scroller = document.createElement("div");
      scroller.className = "ktob-rte-table-scroll__scroller";
      scroller.setAttribute("tabindex", "0");
      scroller.setAttribute("role", "region");
      scroller.setAttribute("aria-label", "表（横にスライドすると続きを読めます）");

      var nudge = document.createElement("button");
      nudge.type = "button";
      nudge.className = "ktob-rte-table-scroll__nudge";
      nudge.setAttribute("aria-label", "表の続きを表示");

      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(scroller);
      scroller.appendChild(table);
      wrap.appendChild(nudge);

      function sync() {
        if (!window.matchMedia(MQ).matches) {
          wrap.removeAttribute(ATTR_RIGHT);
          wrap.removeAttribute(ATTR_LEFT);
          wrap.removeAttribute("data-ktob-scrollable");
          return;
        }
        updateHints(wrap, scroller);
      }

      nudge.addEventListener("click", function (e) {
        e.preventDefault();
        var step = Math.max(120, Math.floor(scroller.clientWidth * 0.7));
        if (typeof scroller.scrollBy === "function") {
          try {
            scroller.scrollBy({ left: step, behavior: "smooth" });
            return;
          } catch (_err) {}
        }
        scroller.scrollLeft += step;
      });

      scroller.addEventListener("scroll", sync, { passive: true });
      window.addEventListener("resize", sync);
      if (window.ResizeObserver) {
        try {
          new ResizeObserver(sync).observe(scroller);
        } catch (_e) {}
      }
      sync();
      window.setTimeout(sync, 100);
      window.setTimeout(sync, 500);
    }

    function run() {
      var roots = document.querySelectorAll(
        ".template-product .product-full-width .rte"
      );
      for (var r = 0; r < roots.length; r++) {
        var tables = roots[r].querySelectorAll("table");
        for (var i = 0; i < tables.length; i++) enhanceTable(tables[i]);
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", run);
    } else {
      run();
    }
    window.addEventListener("load", run);
    document.addEventListener("shopify:section:load", run);
  })();

  /* ---- 2) 空ブロック折りたたみ ---- */
  if (window.__ktobPdpCollapseEmptyBlocks) return;
  window.__ktobPdpCollapseEmptyBlocks = true;

  if (window.Shopify && window.Shopify.designMode) return;

  var KEEP =
    "img,svg,iframe,video,canvas,block-variant-picker,block-buy-buttons,block-price,shopify-app-block,input,select,textarea,button,a,[data-ktob-pdp-panel]";

  function isMeaningful(el) {
    if (!el) return false;
    if (el.matches(KEEP)) return true;
    if (el.querySelector(KEEP)) return true;
    if (el.matches(".shopify-app-block, .shopify-block")) return true;
    if (el.querySelector(".shopify-app-block, .shopify-block, block-variant-picker")) return true;
    return Boolean(el.textContent && el.textContent.trim());
  }

  function collapse() {
    document.querySelectorAll(".product-single__meta > div").forEach(function (wrap) {
      if (isMeaningful(wrap)) return;
      wrap.setAttribute("data-ktob-empty-block", "");
      wrap.hidden = true;
    });

    document.querySelectorAll(".product-single__meta .product-block").forEach(function (block) {
      if (isMeaningful(block)) return;
      block.setAttribute("data-ktob-empty-block", "");
      block.hidden = true;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", collapse);
  } else {
    collapse();
  }
})();
